import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    let lists = this.element.querySelectorAll('[data-list-id]')
    let listsArray = Array.prototype.slice.call(lists);

    listsArray.map((list) => {
      new Sortable(list, {
        group: 'lists_group',
        animation: 150,
        onEnd: this.end.bind(this)
      })
    })
  }

  end(event) {
    let cardId = event.item.dataset.cardId
    let fromListId = event.from.dataset.listId
    let toListId = event.to.dataset.listId

    if (fromListId != toListId) {
      let data = new FormData()
      data.append("position", event.newIndex)
      data.append("card_list_id", toListId)

      const url = this.data.get("url").replace(":id", cardId)
      const request = new FetchRequest('PATCH', url, { body: JSON.stringify(data), responseKind: 'json' } )
      request.perform()
    } else {
      let elem = document.querySelector(`[data-controller='drag'][data-list-id='${toListId}']`)
      elem.drag.move(cardId, event.newIndex)
    }
  }
}
